import { css } from 'styled-components';

const button = css`
  color: var(--white);
  background-color: var(--lightest-slate);
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: var(--fz-xs);
  font-family: var(--font-mono);
  line-height: 1;
  text-decoration: none;
  padding: 1.25rem 1.75rem;
  box-shadow: 0 16px 30px -18px var(--navy-shadow);
  transition: var(--transition);

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: #0f1830;
    box-shadow: 0 22px 36px -18px rgba(24, 34, 53, 0.28);
    transform: translateY(-2px);
  }
  &:after {
    display: none !important;
  }
`;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--green);
      outline: 0;
    }
  `,

  inlineLink: css`
    display: inline-block;
    position: relative;
    color: var(--green);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--green);
      outline: 0;
      &:after {
        width: 100%;
      }
      & > * {
        color: var(--green) !important;
        transition: var(--transition);
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.37em;
      background-color: var(--green);
      opacity: 0.45;
      @media (prefers-reduced-motion: no-preference) {
        transition: var(--transition);
      }
    }
  `,

  button,

  smallButton: css`
    color: var(--white);
    background-color: var(--lightest-slate);
    border: 1px solid transparent;
    border-radius: 999px;
    padding: 0.75rem 1rem;
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    box-shadow: 0 14px 28px -18px var(--navy-shadow);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: #0f1830;
      box-shadow: 0 20px 34px -18px rgba(24, 34, 53, 0.26);
      transform: translateY(-2px);
    }
    &:after {
      display: none !important;
    }
  `,

  bigButton: css`
    color: var(--white);
    background-color: var(--lightest-slate);
    border: 1px solid transparent;
    border-radius: 999px;
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    box-shadow: 0 16px 30px -18px var(--navy-shadow);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: #0f1830;
      box-shadow: 0 22px 36px -18px rgba(24, 34, 53, 0.28);
      transform: translateY(-2px);
    }
    &:after {
      display: none !important;
    }
  `,

  boxShadow: css`
    box-shadow: 0 20px 44px -32px var(--navy-shadow);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      box-shadow: 0 28px 54px -34px rgba(24, 34, 53, 0.2);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
